const GTM_CONTAINER_ID_TEST = "GTM-5CP4QJR";
const SSGTM_DOMAIN = "ssgtm.telia.se";
const init = (config) => {
  const { containerId, dataLayerName = "dataLayer" } = config;
  const auth = "auth" in config ? config.auth : void 0;
  const preview = "preview" in config ? config.preview : void 0;
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": (/* @__PURE__ */ new Date()).getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
    const testConfig = auth && preview ? `&gtm_auth=${auth}&gtm_preview=${preview}&m_cookies_win=x` : "";
    j.async = true;
    j.src = `//${SSGTM_DOMAIN}/gtm.js?id=` + i + dl + testConfig;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", dataLayerName, containerId);
};

export { GTM_CONTAINER_ID_TEST, init };
//# sourceMappingURL=b2x-gtm.esm.js.map
